export default {
  line: "切换线路",
  language: "选择语言",
  common: [
    "在线客服",
    "取消悬浮",
    "机器人",
    "自动视频",
    "开始",
    "今天剩余视频数",
    "设置自动视频数",
    "高级版会员才可使用,请升级",
    "请设置自动视频数"
  ],
  upload: [
    "上传中...",
    "错误格式",
    "上传成功",
    "上传失败"
  ],
  appMsg: [
    "准备下载更新...",
    "下载完成，是否安装更新包",
    "下载更新失败",
    "已下载{num}%",
    "正在更新...",
    "更新成功，即将重启",
    "更新失败",
    "再按一次退出应用"
  ],
  vanPull: [
    "没有更多数据了",
    "没有数据"
  ],
  login: {
    text: [
      "记住密码",
      "正在登录...",
      "立即登录",
      "忘记密码",
      "手机登录",
      "邮箱登录"
    ],
    placeholder: [
      "请输入手机号",
      "请输入登录密码",
      "请输入邮箱地址"
    ],
    i18n: [
      "无{title}账号?",
      "注册"
    ]
  },
  register: {
    text: [
      "欢迎注册",
      "短信码发送中...",
      "获取短信码",
      "正在注册...",
      "立即注册",
      "已有账号，马上下载",
      "手机注册",
      "邮箱注册",
      "获取验证码",
      "短信验证码",
      "邮箱验证码",
      "重发验证码"
    ],
    placeholder: [
      "请输入手机号",
      "请输入短信验证码",
      "请输入登录密码",
      "请确认您的密码",
      "请输入邀请码",
      "两次密码不一样",
      "请输入验证码"
    ],
    i18n: [
      "已有账号?",
      "登录"
    ],
    tips: "注册教程"
  },
  footer: [
    "首页",
    "视频",
    "密聊",
    "客服",
    "我的",
    "收益",
    "众筹",
    "动态",
    "活动"
  ],
  home: {
    broadcast: "Congratulations to the member {member} for recommending a {grade} to get {currency}{reward} promotion rewards!",
    menu: [
      "VIP专区",
      "视频教程",
      "推广奖励",
      "合作媒体",
      "公司实力",
      "账户保险"
    ],
    taskHall: {
      title: [
        "视频大厅",
        "商家发布大厅"
      ]
    },
    memberList: {
      title: "会员榜单",
      data: [
        "祝贺 {member}",
        "今日观看{num}次视频,赚取{currency}{profit}!"
      ]
    },
    businessList: {
      title: "商家榜单",
      data: [
        "{member}",
        "今天发布{num}单视频"
      ]
    },
    noticeTitle: "最新公告",
    msg: "视频未开放",
    video: "暂无视频教程",
    title: ["公司简介","会员等级"]
  },
  postTask: {
    navBar: {
      title: "发布视频",
      right: "发布规则"
    },
    field: [{
        label: "视频分类",
      },
      {
        label: "视频标题",
        placeholder: "请输入视频标题",
        error: "视频标题不能为空"
      },
      {
        label: "视频简介",
        placeholder: "请输入视频简介"
      },
      {
        label: "视频单价",
        placeholder: "请输入视频单价",
        error: "视频单价不能为空"
      },
      {
        label: "领取数量",
        placeholder: "请输入领取数量",
        error: "领取数量不能为空"
      },
      {
        label: "领取次数",
        placeholder: "请输入领取次数",
        right: "次/人",
        error: "领取次数不能为空"
      },
      {
        label: "视频总价",
        error: "视频总价未计算"
      },
      {
        label: "链接信息",
        placeholder: "请输入链接地址",
        error: "链接信息不能为空"
      },
      {
        label: "视频级别",
      },
      {
        label: "截止日期",
        placeholder: "点击选择日期",
        error: "截止日期不能为空"
      },
      {
        label: "完成条件",
        error: "请选择完成条件"
      },
      {
        label: "上传要求",
        placeholder: "请输入上传要求",
      },
      {
        label: "审核样例",
      },
      {
        label: "操作步骤",
        placeholder: "简单易懂的步骤有助于完成!",
        error: "操作步骤不能为空",
        img: "有步骤图未完善"
      },
    ],
    button: "提交",
    step: {
      title: "操作步骤",
      left: "取消",
      right: "完成",
      placeholder: "请输入步骤描述",
      button: [
        "删除",
        "添加"
      ]
    },
    tips: [
      "平台手续费约 {pump}{br}本次发布需支付约 {price}，请保证账户余额充足 {a}{br}提示: 本平台禁止发布黄赌毒及涉政等一切法律所禁止的内容，如发现扣除积分，封禁账号。",
      "去充值",
      "最少保留一项步骤",
      "最多添加十个步骤"
    ]
  },
  vip: {
    user: {
      title: [
        "当前等级",
        "游客"
      ],
      label: "每日视频",
      value: [
        "有效期",
        "永久有效",
        "请先登录",
        "天",
        "到期时间"
      ],
    },
    list: {
      label: "每日视频<b>{number}</b>次",
      button: [
        "立即激活",
        "立即续费"
      ],
      text: [
        "每日收益",
        "月收益",
        "推荐奖励:每名",
        "免费",
        "每单"
      ]
    },
    dialog: [
      "确定花费 {currency} {amount} 成为{name}吗？",
      "你当前为{currname}，无法成为{name}",
      "确定花费 {currency} {amount} 续费{name}吗？"
    ],
    more: "查看更多",
    top: [
      "升级所需",
      "购买返佣",
      ["1级","2级","3级"],
      ["价格","详情"],
      "已过期"
    ]
  },
  user: {
    title: [
      "我的视频",
      "个人记录"
    ],
    default: [
      "我的",
      "登录账号",
      "邀请码",
      "退出登录",
      "余额",
      "金币",
      "我的钱包",
      "封号",
      "限制",
      "良好",
      "优秀",
      "我的上级"
    ],
    grid: [
      "个人余额",
      "昨日收益",
      "今日收益",
      "本周收益",
      "本月收益",
      "上月收益",
      "总收益",
      "今日观看(单)",
      "今日剩余视频(单)",
      "今日提成",
      "今日返利",
      ["今日","昨日","本周","本月"],
      ["观看收益","推广收益","众筹收益","投资收益","投资返佣"],
      ["本周注册","本周有效注册","总工资"],
      ["今日","昨日","三天"]
    ],
    menu: [
      "观看记录",
      "审核视频",
      "发布管理",
      "个人信息",
      "账号绑定",
      "日结报表",
      "账变记录",
      "邀请好友",
      "团队报表",
      "帮助手册",
      "信用中心",
      "APP下载",
      "我的投资"
    ]
  },
  userInfo: {
    default: [
      "个人信息",
      "头像",
      "手机号",
      "银行卡",
      "支付宝",
      "实名认证",
      "登录密码",
      "资金密码",
      "点击设置",
      "修改头像",
      "修改登录密码",
      "修改资金密码",
      "提交",
      "清空缓存",
      "USDT钱包",
      "推送开关",
      "我的地址"
    ],
    label: [
      "原登录密码",
      "新登录密码",
      "确认密码",
      "原资金密码",
      "新资金密码",
      "确认密码",
      "忘记资金密码",
      "短信验证码",
      "验证码"
    ],
    placeholder: [
      "请输入原登录密码",
      "请输入新登录密码",
      "请确认登录密码",
      "请输入原资金密码",
      "请输入新资金密码",
      "请确认资金密码"
    ]
  },
  userSet: {
    default: [
      "实名认证",
      "详细信息",
      "绑定支付宝",
      "提交",
      "绑定USDT钱包",
      "更改钱包地址",
      "邮箱验证",
      "示例图",
      ["审核中","审核成功","审核失败"]
    ],
    label: [
      "真实姓名",
      "QQ号",
      "支付宝账号",
      "支付宝姓名",
      "钱包类型",
      "钱包地址",
      "详细地址",
      "联系人",
      "电话",
      "钱包截图"
    ],
    placeholder: [
      "请输入真实姓名(本人姓名提现所用)",
      "请输入QQ号",
      "请输入支付宝账号",
      "请输入支付宝姓名",
      "请选择钱包类型",
      "请输入钱包地址",
      "请输入详细地址",
      "请先实名认证",
      "请先绑定电子邮箱"
    ],
    tips: "温馨提示：绑定银行卡不可以修改，为您提款使用"
  },
  bindAccount: {
    default: [
      "绑定账号",
      "查看教程",
      "提交"
    ],
    tabs: [
      "账号",
      "账号",
      "账号"
    ],
    label: [
      "操作说明",
      "添加截图",
      "账号"
    ],
    placeholder: "请输入{account}账号"
  },
  bankCard: {
    default: [
      "绑定银行卡",
      "立即认证",
      "正在提交...",
      "立即添加",
      "添加"
    ],
    tips: [
      "请实名认证后再来添加银行卡",
      "您绑定银行卡的开户名必须与您认证的实名一致，否则将无法成功提现。"
    ],
    label: [
      "姓名",
      "银行名称",
      "银行帐户",
      "IFSC代码"
    ],
    placeholder: [
      "请选择银行名称",
      "请输入银行帐户",
      "请输入IFSC代码"
    ]
  },
  wallet: {
    default: [
      "我的钱包",
      "充值",
      "提现",
      "充值记录",
      "提现记录",
      "充",
      "提",
      "支付宝"
    ],
    label: [
      "提现方式",
      "提现金额",
      "资金密码",
      "提交",
      "手机号",
      "邮箱",
      "IFSC"
    ],
    placeholder: [
      "选择提现方式",
      "请输入提现金额",
      "请输入资金密码",
      "请选择提现方式",
      "请输入收款人手机号",
      "请输入收款人邮箱",
      "请输入收款人IFSC"
    ],
    msg: [
      "你还未设置资金密码，请先设置",
      "你还未绑定银行卡，请先绑定"
    ]
  },
  recharge: {
    default: [
      "充值",
      "充值详情",
      "充值记录",
      "可用余额{money}，请选择充值方式",
      "单笔最低金额为{currency}{min}，最高{currency}{max}，手续费{fee}%",
      "正在提交...",
      "立即充值",
      "返回",
      "加载中..."
    ],
    label: [
      "充值金额",
      "充值通道",
      "转账姓名",
      "付款人姓名",
      "付款人手机",
      "付款人UPI账户",
      "付款人邮箱"
    ],
    placeholder: [
      "请输入充值金额",
      "请选择充值通道",
      "请输入转账姓名",
      "单笔最低金额为{currency}{min}",
      "单笔最高金额为{currency}{max}",
      "请输入付款人姓名",
      "请输入付款人手机号，号码前加上国际区号，例如+86",
      "请输入付款人UPI账户",
      "请输入付款人邮箱"
    ],
    info: [
      "充值金额",
      "订单号",
      "收款银行",
      "收款账号",
      "收款人",
      "复制",
      "{type} 转账",
      "转账截图",
      "提交",
      "IFSC代码",
      "UPI",
      "处理说明",
      "钱包地址",
      "收款二维码",
    ],
    tips: [
      "请选择以下方式转账相符的金额以免延误财务查收<br>转账后请上传转账截图作为核对证明",
      "请扫描二维码转账您的充值金额",
      "请按照下面信息完成转账",
      "提示：成功支付后，请联系在线客服，提供您的会员账号、充值金额、订单号、存款人帐号、充值时间；方便财务及时为您添加资金",
      "注意：会员每笔转账支付请提交一次",
      "转账后请上传转账截图作为核对证明",
      "请选择以下方式转账相符的金额",
      "请上传转账截图",
      "汇率:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})",
      "充值返还"
    ]
  },
  task: {
    default: [
      "观看记录",
      "视频要求",
      "创建",
      "审核",
      "打开链接",
      "复制链接",
      "单价",
      "提交",
      "放弃",
      "观看时间"
    ],
    tabs: [
      "进行中",
      "审核中",
      "已完成",
      "已失败",
      "恶意",
      "已放弃"
    ],
    msg: "请上传完成视频图片",
    info: [
      "视频详情",
      "视频标题",
      "视频收益",
      "视频描述",
      "上传要求",
      "提交样例",
      "用户未提交样例",
      "审核说明",
      "审核日期",
      "需求方",
      "发布",
      "复制",
      "跳转",
      "视频步骤",
      "第{index}步",
      "审核样例",
      "无审核样例",
      "数据加载中...",
      "放弃视频",
      "开始观看",
      "发布内容"
    ],
    index: [
      "当前身份",
      "您当前的等级为 <i style=\"color:#1989fa\">{currVip}</i><br>只能领取当前<i style=\"color:#1989fa\">{currVip}</i>等级的视频<br>是否加入 <i style=\"color:#dd6161\">{vip}</i> 等级",
      "立即加入",
      "请选择视频类别"
    ],
    list: [
      "视频列表",
      "需求方",
      "剩余",
      "要求",
      "领取"
    ],
    show: [
      "视频详情",
      "人已赚到",
      "剩余{num}个名额",
      "48小时内审核",
      "视频描述",
      "需求方",
      "审核标准",
      "复制",
      "跳转",
      "视频步骤",
      "第{index}步",
      "审核样例",
      "无审核样例",
      "数据加载中...",
      "正在提交...",
      "领取视频",
      "立即登录",
      "发布内容"
    ]
  },
  audit: {
    default: [
      "审核视频",
      "领取用户",
      "领取日期",
      "更新日期",
      "审核",
    ],
    tabs: [
      "进行中",
      "审核中",
      "已完成",
      "已失败"
    ],
    info: [
      "审核详情",
      "视频标题",
      "视频金额",
      "人已完成",
      "剩余{num}个名额",
      "视频描述",
      "链接信息",
      "审核样例",
      "领取用户",
      "领取",
      "完成状态",
      "提交样例",
      "用户未提交样例",
      "更新日期",
      "数据加载中...",
      "恶意",
      "重审",
      "失败",
      "成功",
      "审核视频",
      "审核说明",
      "请输入审核说明",
      "提交的视频不合格，需重新提交审核",
      "祝贺视频完成，再接再厉",
      "提交的视频页面截图错误，视频失败",
      "恶意提交视频，视频失败"
    ]
  },
  postRecord: [
    "发布管理",
    "发布",
    "总量",
    "已完成",
    "截止日期",
    "审核",
    "撤销",
    "编辑"
  ],
  dayReport: [
    "日结报表",
    "总收益",
    "我完成的视频",
    "我的视频收益",
    "下级完成的视频",
    "下级视频收益",
    "单",
    "最近30天",
    "数量",
    "视频",
    "下级",
    "消费",
    "日期"
  ],
  fundRecord: {
    default: [
      "支出记录",
      "充值记录",
      "收入记录",
      "充",
      "收",
      "支"
    ],
    tabs: [
      "收入",
      "支出",
      "充值"
    ]
  },
  promote: [
    ["每邀请{num}位有效用户","赚","现金"],
    "可直接提现",
    "每邀请{num}位有效用户",
    ["每日领奖","每人每天都可以领取"],
    ["有效用户","每天邀请{num}位有效用户"],
    ["邀请","领取","立即邀请"],
    "团队员工奖",
    ["星代理","奖金","工资"],
    ["人","要求","已邀请"],
    "佣金介绍",
    ["分享","立即领取"],
    ["分享到社交平台","分享"],
    ["充值","自己充值","充值"],
    ["矿机","购买矿机","购买"],
    ["理财","投资理财","投资"],
    ["立即分享给好友","邀请码"],
    ["复制链接","复制邀请码","二维码","分享海报"],
    "保存图片",
    "好友升级VIP奖励",
    "详情"
  ],
  teamReport: {
    default: [
      "搜索",
      "团队余额",
      "团队收益",
      "团队充值",
      "团队提现",
      "首充人数",
      "首推人数",
      "团队人数",
      "团队新增",
      "个",
      "我",
      "用户",
      "充值",
      "提现",
      "返点",
      "视频",
      "选择年月日",
      "暂无数据",
      "充值金额",
      "充值人数",
      "推广收益",
      "VIP总人数",
      "有效人数"
    ],
    tabs: [
      "团队报表",
      "我的团队"
    ],
    team: [
      "一级",
      "二级",
      "三级"
    ]
  },
  help: [
    "帮助手册",
    "暂无内容"
  ],
  credit: [
    "信用中心",
    "信用说明",
    "信用记录",
    "<p>1.信用积分每周评估一次</p><p>2.初始用户信用积分:<b>60</b></p><p>3.如果检测到用户做视频上传虚假图片一天扣除:<b>1</b>积分,扣分上限:<b>7</b>积分</p><p>4.如果未检测到用户使用虚假图片增加<b>1</b>积分</p><p>5.信用积分低于<b>50</b>分将被限制提现</p><p>6.信用积分低于<b>30</b>分接视频次数减半</p><p>7.信用积分小于等于<b>0</b>分将被封号</p>",
    "我的信用",
    "暂时没有信用记录"
  ],
  appDown: [
    "APP下载",
    "扫描二维码下载APP",
    "保存二维码",
    "保存二维码成功",
    "保存二维码失败，请多试几次或截屏保存",
    "复制",
    "Android下载",
    "IOS下载",
    "如果IOS版本无法正常下载，请卸载原版重新下载安装。 不卸载会影响使用"
  ],
  dialog: [
    "提示",
    "确定",
    "正在提交...",
    "复制成功",
    "IOS系统版本低不支持",
    "正在注册...",
    "数据加载中...",
    "暂未开放，敬请期待",
    "保存图片成功",
    "保存图片失败<br>如不成功请多试几次或截屏保存",
    "浏览器不支持，请截图",
    "招商進行中",
    "目前没有付款计划"
  ],
  lineList: [
    "线路选择",
    "当前线路",
    "线路"
  ],
  serviceCenter: [
    "客服中心",
    "Hi，专属客服",
    "很高兴为您服务",
    "自助服务",
    "在线客服",
    "充值客服",
    "Line客服",
    "联系",
    "帮助手册",
    "网站公告"
  ],
  theme: {
    title: "切换主题",
    black:"黑色主题",
    white: "白色主题",
    green: "墨绿主题"
  },
  Finance: [
    ["每日分紅","赠送股权","赠送期权","额外补贴","倍"],
    "立即抢购",
    "理财详情",
    "订单价格",
    ["百分比","天"],
    "立即报单",
    ["账户余额","项目单价","每日分紅","项目周期","天","购买份数","最大购买份数","预计可得收益"],
    "提交",
    "我的理财",
    ["取息","结束","详情"],
    ["确定取出利息吗,取出后将重新计息","确定结束此理财吗"],
    "订单详情",
    ["总金额","订单状态","购买日期"]
  ],
  Video: [
    ["游客","升级可享更多收益"],
    "立即升级",
    ["今日收益","每单","去提现"],
    ["今日已看视频次数","剩余次数"],
    "开始观看",
    "登录观看",
    "全屏观看",
    "关闭",
    ["推荐您下载","免费下载"],
    "在线人数",
    "一键完成",
    "请先绑定手机号",
    "请先绑定电子邮箱"
  ],
  Disclaimer: [
    ["已经阅读并同意","免责声明"],
    ["登录协议","不同意","同意"]
  ],
  Withdraw: [
    "可用余额{money}，请选择提现账户",
    "提现账户",
    "请选择提现账户",
    "提现金额",
    "请输入提现金额",
    "钱包地址",
    "请输入钱包地址",
    "资金密码",
    "请输入资金密码",
    "立即提现",
    "汇率: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
    "选择提现账户",
    ["添加银行账户","绑定USDT钱包"],
    "实际到账",
    "手机号",
    "请输入手机号",
    "邮箱",
    "请输入邮箱",
    "UPI",
    "请输入UPI",
    "USDT提现仅支持使用TRUST钱包",
    "下载TRUST钱包"
  ],
  Partner: [
    "众筹等级",
    "众筹",
    ["发起众筹","参与众筹","我的众筹"],
    ["众筹等级","请选择众筹等级"],
    ["众筹份数","请选择众筹份数"],
    ["购买份数","请输入购买份数"],
    "每份金额",
    "立即众筹",
    ["进行中","已完成"],
    ["发起人","众筹等级","众筹份数","每份金额","已购","份","追加","利润","参与","众筹日期"],
    "众筹规则",
    ["众筹名称","请输入众筹名称"]
  ],
  Share: [
    "每日奖金",
    ["任务列表","作弊刷注册的用户将会被封禁","去分享"],
    ["任务步骤","每天可上传{num}次"],
    ["提款到账的图片","成功分享到群聊的提款图片","提交垃圾内容的用户将被封号"," 审核通过之后，奖励将发放到您的账户"],
    ["请选择截图上传","请输入你的{name}链接地址","图片示例"],
    "提交",
    "分享",
    "分享今日收益",
    "步骤说明",
    "分享文案",
    "复制文案",
    "提交截图或链接",
    "取消",
    "可得奖励",
    "奖金"
  ],
  Community: [
    "动态",
    ["最新","提现","购买","佣金","收益"],
    ["价格","单次观看收益","每日视频次数"],
    "我也要升级"
  ],
  Register: [
    "请输入电子邮箱",
    ["请输入电子邮箱验证码","获取邮箱码","邮箱验证码"]
  ],
  UserInfo: [
    ["电子邮箱","点击绑定"],
    ["绑定手机","绑定邮箱"],
    ["手机号","请输入手机号"],
    ["电子邮箱","请输入电子邮箱"],
    "请先绑定手机号再提现",
    "请先绑定电子邮箱再提现",
    ["Telegram认证","认证教程"]
  ],
  Bet: [
    "距离{no}期开奖",
    "等待开奖",
    "账户余额",
    "期",
    "期号",
    "投注内容",
    "注数",
    "金额",
    "状态",
    "无记录",
    "收起",
    "时间",
    "期号",
    "开奖号码",
    "总和",
    "我要投注",
    "恭喜<em id='win_name'>{name}</em>在<i id='win_lottery'>{lottery}</i>中投注，中奖<em id='win_money'>{currency}{price}</em>",
    "我的<br>投注",
    "趋势",
    "玩法",
    "玩法说明",
    "正在连接房间...",
    "等待开奖",
    "未中奖",
    "已中{price}",
    "已删除",
    "已撤单",
    "已停止",
    "走水",
    "发送失败，点击消息重新发送",
    "该投注房间不存在",
    "是否跟注",
    "跟注",
    "您的浏览器不支持WebSocket协议",
    "聊天室通信失败，正在尝试重接",
    "温馨提示，",
    "秒之后清屏",
    "你的浏览器不支持",
    "投注类型",
    "你还未登录，请先登录",
    "只能发送图片",
    "账户余额不足{balance},不能进入该房间,请充值",
    "走势",
    "官网",
    "盈利",
    ["投注","中奖","返点","盈利"],
    ["今日","昨日","本周","本月","总计"]
  ],
  BetView: [
    "最大赔率",
    "奖金",
    "快捷金额",
    "注",
    "输入金额",
    "取消",
    "追号",
    "立即投注",
    "数据加载中...",
    "投注内容",
    "赔率",
    "请输入投注金额",
    "当前期号未开放",
    "等待开奖中，不能投注",
    "本期已经封单，请投注下一期",
    "请选择投注内容",
    "一键跟投",
    "期号",
    "期",
    "玩法",
    "投注内容",
    "投注金额",
    "跟单",
    "仅供VIP用户开放"
  ],
  Coupon: [
    "代金券",
    ["待使用", "已使用", "已过期"],
    ["代金券","有效期至","价值"],
    "转赠",
    ["全选","请输入转赠用户名","确认","取消"]
  ],
  Trend: [
    "走势",
    ["30期","50期","100期"],
    ["单号走势","多号走势","大小走势","单双走势","和值|形态"],
    ["百位","十位","个位","三码","前二","后二","三码和值"],
    ['百十个,3', '百位,2', '十位,2', '个位,2'],
    ['百十个,3', '和值', '形态,2'],
    ["大","小"],
    ["双","单"],
    ["大","小","和","双","单"],
    "期",
    ["期数","出现次数","最大连出","最大遗漏","平均遗漏"]
  ],
  BlindBox: [
    "奖品记录"
  ],
  Activity: [
    "活动",
    ["全部","代理","会员","战略合作","已结束"],
    "查看详情"
  ],
  Invest: [
    "理财项目",
    "保",
    "日化利率",
    "年化利率",
    "天",
    "投资期限",
    "总利率",
    "起投金额",
    "总发行份数：{num}",
    "项目规模：{currency} {project_scale}",
    "立即投资",
    "出售完毕",
    "项目进度",
    "账户可用余额",
    "项目可投金额",
    "项目名称",
    "投资金额",
    "结息时间",
    "投资金额",
    "最低起投",
    "递增",
    "可获得收益",
    "资金密码",
    "请输入资金密码,默认为登录密码",
    "立即投资",
    "请先进行实名认证",
    "你还未设置资金密码，去设置"
  ],
  InvestOrder: [
    "份",
    ["每份分红","项目周期","天","投资金额"],
    ["项目名称","投资金额","状态","操作"],
    ["转出","详情"]
  ],
  InvestDetail: [
    "投资详情",
    "投资金额",
    "预期效益",
    "投资时间",
    "到期时间",
    "收益方式",
    "期号",
    "应收本金",
    "应收利息",
    "应收总额",
    "支付时间",
    "已支付",
    "状态",
    "第{no}期",
    "合同",
    "合同详情"
  ],
}